import React, { useState, useRef, useEffect } from 'react';
import s from './ToolsButtons.module.css';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../../../store/store';
import IconRetry from '../../../../shared/ui/icons/emodji/IconRetry';
import Button from '../../../../shared/ui/button/Button';
import { toggleActivePrompt } from '../../../../store/slices/pageSlice';
import { generateContent, updateProject } from '../../../../shared/api/textProjectApi';
import {
    selectCurrentProject,
    selectImageData,
} from '../../../../store/selectors/projectSelectors';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
interface RetryButtonProps {
    isActive?: boolean;
    onClick?: () => void;
    mode: 'text' | 'image';
}

const RetryButton: React.FC<RetryButtonProps> = ({ isActive, onClick, mode }) => {
    const { projectId } = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [showMenu, setShowMenu] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const currentProject = useSelector(selectCurrentProject);
    const imageData = useSelector(selectImageData);

    const handleGenerateContent = async () => {
        if (mode === 'text') {
            onClick?.();
            if (projectId) {
                try {
                    const response = await dispatch(
                        generateContent({ projectId, kind: 'text_only' }),
                    ).unwrap();
                    console.log('Text script generated:', response);
                } catch (error: any) {
                    toast.error(error?.message || 'Failed to generate text script');
                    console.error('Retry failed:', error);
                }
            }
        } else {
            setShowMenu((prev) => !prev);
        }
    };

    const handleGenerate = () => {
        if (location.pathname.includes('/text_project')) {
            navigate(`/image_project/${imageData?.id}`);
        }

        dispatch(toggleActivePrompt('image_prompt'));
        setShowMenu(false);
    };

    const handleUpload = () => {
        if (location.pathname.includes('/text_project')) {
            navigate(`/image_project/${imageData?.id}`);
        }

        dispatch(toggleActivePrompt('image_uploads'));

        setShowMenu(false);
    };

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (showMenu && wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setShowMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showMenu]);

    return (
        <div className={s.wrapper} ref={wrapperRef}>
            <button
                className={`${s.container} ${isActive ? s.active : ''}`}
                onClick={handleGenerateContent}
            >
                <IconRetry />
                <p>Retry</p>
            </button>

            {showMenu && (
                <div className={s.context_menu}>
                    <p className={s.title}>Would you like to?</p>
                    <div className={s.buttons_container}>
                        <Button
                            text="Generate"
                            onClick={handleGenerate}
                            style={{
                                width: '75px',
                                borderRadius: '4px',
                                height: '26px',
                                fontSize: '10px',
                                backgroundColor: '#FFDD35',
                            }}
                        />
                        <Button
                            text="Upload"
                            onClick={handleUpload}
                            style={{
                                width: '75px',
                                borderRadius: '4px',
                                height: '26px',
                                fontSize: '10px',
                                backgroundColor: '#FFDD35',
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default RetryButton;
